import { ProductAggregatedStatUruchomieniaSum } from "@/store/modules/statsUruchomienia/types";


export class State {
    aggregatedStatsUruchomieniaSumUpdating: boolean = false;
    aggregatedStatsUruchomieniaSum: Array<ProductAggregatedStatUruchomieniaSum> = [];
    aggregatedStatsUruchomieniaSumBuffer: Array<ProductAggregatedStatUruchomieniaSum> = [];

    aggregatedStatsUruchomieniaLoading: boolean = false;
    aggregatedStatsUruchomienia: Array<object> = [];
    aggregatedStatsUruchomieniaCurrentPage: number = 1;
    aggregatedStatsUruchomieniaTotal: number = 0;

    detailedStatsUruchomieniaLoading: boolean = false;
    detailedStatsUruchomienia: Array<object> = [];
}


